import FormLabel from '@c/forms/controls/FormLabel';
import SafeImage from '@ui/SafeImage';
import Select from '@ui/Select';
import PlusIcon from '@i/plus.svg';
import { PricingSection } from '@c/PricingSection';
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getPaymentMethods } from '@util/firestore/payments';
import AddPaymentMethodModal from '@c/modals/AddPaymentMethodModal';
import { CreateListingSection } from './CreateListingSection';
import { useCreateListing } from '../_context';

export const CarListingPackage = () => {
  const { form, product, checkIncludes, isSimListing } = useCreateListing();
  const [addPaymentModalIsOpen, setAddPaymentModalIsOpen] = useState(false);

  const { data: paymentData, isLoading } = useQuery({
    queryKey: ['paymentMethods'],
    queryFn: () => getPaymentMethods(),
  });

  const paymentOptions = useMemo(
    () =>
      paymentData?.map((paymentMethod) => ({
        label: `${paymentMethod.brand?.toUpperCase()} ending in ${
          paymentMethod.last4
        }`,
        id: String(paymentMethod.id),
        value: String(paymentMethod.id),
      })) ?? [],
    [paymentData]
  );

  useEffect(
    () => form.setValue('bike_package_ch', paymentOptions.at(0)?.id),
    [paymentOptions, form]
  );

  const paymentMethod = form.watch('bike_package_ch');

  const onChangePlan = (pckg: 1 | 2) => form.setValue('bike_package', pckg);

  const isRaceCarListing = checkIncludes(['race cars']);
  const listingKind = isRaceCarListing
    ? 'race car'
    : isSimListing
    ? 'sim'
    : 'kart';

  return (
    <CreateListingSection title={`Choose ${listingKind} listing package`}>
      <PricingSection
        listing
        popular="2nd Gear"
        variant={isSimListing ? 'sim' : 'race-car'}
        selectedPlan={product.bike_package}
        setSelectedPlan={onChangePlan}
      />
      <span className="text-heading-h6 font-bold">Buy this package</span>
      <div className="flex w-full flex-col justify-between gap-12 lg:flex-1 lg:flex-row">
        <div
          className={`${
            product.bike_package !== 1 ? 'visible' : 'invisible'
          } flex w-full flex-col gap-4 lg:w-2/3`}
        >
          <FormLabel value="Select payment" required>
            <Select
              options={paymentOptions}
              value={paymentMethod}
              placeholder="Select from you saved payments"
              className="w-full border border-[#d9d9d9]"
              allowEmpty={false}
              onChange={(value) => form.setValue('bike_package_ch', value.id)}
              disabled={isLoading}
            />
          </FormLabel>
          <button
            className="flex w-fit items-center gap-2 text-body-md font-semibold text-text-red"
            type="button"
            onClick={() => setAddPaymentModalIsOpen(true)}
          >
            <SafeImage src={PlusIcon} alt="plus icon" height={24} width={24} />
            Add new payment
          </button>
        </div>
        <div className="flex flex-1 flex-col items-center justify-center gap-4">
          <span className="text-body-md font-medium text-text-muted">
            Total purchase
          </span>
          <span className="text-heading-h3 font-bold">
            {product.bike_package === 1 ? 'Free' : '$39.99'}
          </span>
        </div>
      </div>
      <AddPaymentMethodModal
        isOpen={addPaymentModalIsOpen}
        dismiss={() => setAddPaymentModalIsOpen(false)}
      />
    </CreateListingSection>
  );
};
